module.exports = __webpack_public_path__ + "static/media/adesivo_alluria.5307cad2.png";